import React from "react";
import { Link } from "react-router-dom";
import { getPortalUrl } from "../../config/domains";
import useCaseHeroImg from "../../images/use-case/use-case-hero.png";

const HeroSection = () => {
  return (
    <section className="w-full px-4 sm:px-6 lg:px-8 pt-4 pb-12">
      <div className="max-w-9xl mx-auto bg-[#F2F7F4] rounded-[28px] sm:rounded-[36px] lg:rounded-[42px] p-6 sm:p-10 lg:p-14 overflow-hidden">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
          {/* Left Content Column */}
          <div className="lg:col-span-6 flex flex-col justify-center text-left" data-aos="fade-right">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-[54px] font-extrabold text-[#0d3429] tracking-tight leading-[1.12] font-['Axiforma',sans-serif]">
              Multilingual Solutions <br className="hidden sm:inline" />
              For Every Industry
            </h1>

            <p className="text-[#4a6358] text-base sm:text-lg md:text-[18px] leading-relaxed mt-5 mb-8 max-w-xl font-normal">
              Deliver communication that is accurate, culturally aware and accessible across voice, text and real-world workflows
            </p>

            <div className="flex flex-wrap items-center gap-4">
              <a
                href={getPortalUrl("/user-dashboard/developer-tools")}
                className="inline-flex items-center justify-center bg-[#1a5f4c] hover:bg-[#144b3c] text-white text-base font-semibold px-7 py-3.5 rounded-xl transition-all duration-200 shadow-sm hover:shadow hover:-translate-y-0.5"
              >
                Get An API Key
              </a>

              <Link
                to="/contact-us"
                className="inline-flex items-center justify-center bg-[#e8f0ec] hover:bg-white hover:text-[#0d3429] border border-[#d2e0d8] text-base font-semibold px-7 py-3.5 rounded-xl transition-all duration-200 hover:shadow-sm"
              >
                Talk To Our Team
              </Link>
            </div>
          </div>

          {/* Right Image Column */}
          <div className="lg:col-span-6 flex items-center justify-center" data-aos="fade-left">
            <div className="w-full rounded-[24px] sm:rounded-[30px] overflow-hidden shadow-md border border-[#e2ece5] bg-white">
              <img
                src={useCaseHeroImg}
                alt="Multilingual Solutions For Every Industry"
                className="w-full h-auto object-cover max-h-[460px] sm:max-h-[500px] w-full"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
